import { authorizedRequest, authorizedRequestJson } from '../lib/authSession';

export function listDocuments({ token, memberId }) {
  const query = memberId ? `?memberId=${encodeURIComponent(memberId)}` : '';
  return authorizedRequestJson(`/documents${query}`);
}

export function createDocumentUpload({ token, memberId, fileName, contentType }) {
  return authorizedRequestJson('/documents/upload', {
    method: 'POST',
    body: { memberId, fileName, contentType },
  });
}

export function createDocument({ token, memberId, documentId, fileName, contentType }) {
  return authorizedRequestJson('/documents', {
    method: 'POST',
    body: { memberId, documentId, fileName, contentType },
  });
}

export function updateDocument({ token, memberId, documentId, fileName, documentType }) {
  return authorizedRequestJson(`/documents/${encodeURIComponent(memberId)}/${encodeURIComponent(documentId)}`, {
    method: 'PATCH',
    body: { fileName, documentType },
  });
}

export async function deleteDocument({ token, memberId, documentId }) {
  const response = await authorizedRequest(
    `/documents/${encodeURIComponent(memberId)}/${encodeURIComponent(documentId)}`,
    {
      method: 'DELETE',
    }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message ?? 'Request failed.');
  }
}

export function getDocumentViewUrl({ token, memberId, documentId }) {
  return authorizedRequestJson(`/documents/${encodeURIComponent(memberId)}/${encodeURIComponent(documentId)}/view-url`);
}

export function getDocumentDownloadUrl({ token, memberId, documentId }) {
  return authorizedRequestJson(`/documents/${encodeURIComponent(memberId)}/${encodeURIComponent(documentId)}/download-url`);
}
